import fetchAPI from '../fetchAPI';

export const callGetAllTablePreferences = async (): Promise<
  iResponse<Record<string, TablePrefs>>
> => {
  const response: iResponse<Record<string, TablePrefs>> = await fetchAPI({
    method: `GET`,
    route: `user/preferences/tables`
  });

  return response;
};

export default callGetAllTablePreferences;
